import { formatDistanceToNowStrict, format, isAfter } from 'date-fns'
import { pt } from 'date-fns/locale'
import type { Timestamp } from 'firebase/firestore'

export function fromTimestamp(ts: Timestamp | null | undefined): Date {
  if (!ts) return new Date()
  return ts.toDate()
}

// Plates are stored exactly as typed (no normalization on write), so compare
// case/punctuation-insensitively — mirrors normalizePlate() in the Worker.
export function normalizePlate(s: string): string {
  return s.toUpperCase().replace(/[^A-Z0-9]/g, '')
}

// Sempre em pt-PT. Sem `locale`, o date-fns escreve em inglês — a app
// mostrava "about 18 hours restantes" e "6 months ago" ao lado de português.
export function relativeTime(ts: Timestamp | null | undefined): string {
  if (!ts) return '—'
  return formatDistanceToNowStrict(fromTimestamp(ts), { addSuffix: true, locale: pt })
}

export function absoluteDate(ts: Timestamp | null | undefined): string {
  if (!ts) return '—'
  return format(fromTimestamp(ts), 'd MMM yyyy', { locale: pt })
}

export function absoluteDateTime(ts: Timestamp | null | undefined): string {
  if (!ts) return '—'
  return format(fromTimestamp(ts), "d MMM yyyy, HH:mm", { locale: pt })
}

export function formatCurrency(amount: number, currency = 'EUR'): string {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(amount)
}

export function isSlaBreached(deadline: Timestamp | null | undefined): boolean {
  if (!deadline) return false
  return isAfter(new Date(), fromTimestamp(deadline))
}

export function slaTimeRemaining(deadline: Timestamp | null | undefined): string {
  if (!deadline) return '—'
  const now = new Date()
  const end = fromTimestamp(deadline)
  if (isAfter(now, end)) return 'Prazo excedido'
  return `Faltam ${formatDistanceToNowStrict(end, { locale: pt })}`
}
